import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment-timezone';
import { ComponentsService } from 'src/app/components.service';
import { TimeZoneService } from 'src/app/services/time-zone.service';

interface TimezoneInfo {
    name: string;
    currentTime: string;
    offset: string;
    offsetMinutes: number;
}

@Component({
    selector: 'app-time-zone',
    templateUrl: './time-zone.component.html',
    styleUrls: ['./time-zone.component.scss']
})
export class TimeZoneComponent implements OnInit {
    timezoneNames: string[] = moment.tz.names();
    showTimezonePanel: boolean = false;
    selectedTimezone: string = '';
    timezones: TimezoneInfo[] = [];
    selectedTimezoneInfo: TimezoneInfo | null = null;
    searchText: string = '';

    constructor(
        private service: ComponentsService,
        private timeZoneService: TimeZoneService
    ) {}

    ngOnInit(): void {
        this.selectedTimezoneInfo = this.getTimezoneInfo(moment.tz.guess());

        this.timezoneNames.forEach((timezone) => {
            this.timezones.push(this.getTimezoneInfo(timezone));
        });
        this.sortTimezonesByOffset();
    }

    toggleTimezonePanel() {
        this.showTimezonePanel = !this.showTimezonePanel;
    }

    filterTimezones() {
        const searchTerm = this.searchText.toLowerCase();
        this.timezones = this.timezoneNames
            .filter((timezone) => timezone.toLowerCase().includes(searchTerm))
            .map((timezone) => this.getTimezoneInfo(timezone));
        this.sortTimezonesByOffset();
    }

    selectTimezone(timezone: string) {
        if (this.selectedTimezone) {
            const prevSelectedElement = document.querySelector(
                `.timezone-item[selected="${this.selectedTimezone}"]`
            );
            if (prevSelectedElement) {
                prevSelectedElement.classList.remove('selected');
            }
        }

        this.selectedTimezone = timezone;
        this.selectedTimezoneInfo = this.getTimezoneInfo(timezone);
        this.service.setTimeZoneOffset(this.selectedTimezoneInfo.offsetMinutes);
        this.service.timeZoneChanged.emit(
            this.selectedTimezoneInfo.offsetMinutes
        );
        this.timeZoneService.setTimeZone(timezone);
        this.showTimezonePanel = false;

        const selectedElement = document.querySelector(
            `.timezone-item[selected="${timezone}"]`
        );
        if (selectedElement) {
            selectedElement.classList.add('selected');
        }
    }

    getTimezoneInfo(timezone: string): TimezoneInfo {
        let currentTime = moment().tz(timezone).format('DD/MM/YYYY HH:mm');
        let zone = moment.tz.zone(timezone);
        let offsetMinutes = zone.utcOffset(Date.now());
        let offsetSign = offsetMinutes <= 0 ? '+' : '-';
        let offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
        let offsetMinutesAbs = Math.abs(offsetMinutes) % 60;
        let offset = `${offsetSign}${offsetHours.toString().padStart(2, '0')}:${offsetMinutesAbs.toString().padStart(2, '0')}`;

        return {
            name: timezone,
            currentTime,
            offset,
            offsetMinutes
        };
    }

    sortTimezonesByOffset() {
        this.timezones.sort((a, b) => {
            if (a.offsetMinutes < b.offsetMinutes) {
                return -1;
            } else if (a.offsetMinutes > b.offsetMinutes) {
                return 1;
            } else {
                return 0;
            }
        });
    }
}
